/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import {MatDialog} from '@angular/material/dialog';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
  ){ }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.authService.token$.pipe(
        filter(token => token !== null), // Filter until the token is not null
        take(1),
        map(token => {
          if (token) {
            
            return true;
          } else {
             const loginRoute = this.authService.getRedirectLoginRoute();
            return this.router.createUrlTree([loginRoute]); // Redirect to the login page if there is no token
          }
        })
      );
    }
}
